import { render, staticRenderFns } from "./new-password.vue?vue&type=template&id=1646cd63&scoped=true&"
import script from "./new-password.vue?vue&type=script&lang=js&"
export * from "./new-password.vue?vue&type=script&lang=js&"
import style0 from "./new-password.vue?vue&type=style&index=0&id=1646cd63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1646cd63",
  null
  
)

/* custom blocks */
import block0 from "./new-password.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(component)

export default component.exports